<template>
  <sticky-header-layout>
    <template #header>
      <list-page-header>
        <div slot="right">
          <div>
            <el-input
              v-model="keywords"
              placeholder="Name / Ad Name / U1 / Title"
              clearable
              style="width:200px; margin-right:8px;"
            />
            <el-button
              :disabled="keywords===''"
              type="primary"
              @click="handleSearchDealPost"
            >
              Go
            </el-button>
            <el-button
              class="add-button"
              type="primary"
              icon="el-icon-edit"
              @click="handleCreate"
            >
              {{ $t('button.create') }}
            </el-button>
            <el-button
              :disabled="dealPostForm.adName===''"
              size="mini"
              type="info"
              icon="el-icon-document-copy"
              v-clipboard:copy="dealPostForm.adName"
            >
              Ad Name
            </el-button>
            <el-button
              :disabled="dealPostForm.facebookCampaignId==='' || dealPostForm.facebookAdSetId===''"
              size="mini"
              type="info"
              icon="el-icon-document-copy"
              v-clipboard:copy="adIds"
            >
              Ad IDs
            </el-button>
            <el-button
              :disabled="!isEditMode"
              size="mini"
              type="info"
              icon="el-icon-document-copy"
              @click="handleActionAfterCopyAdContent"
            >
              Ad Content
            </el-button>
            <el-button
              :disabled="isSaving || isDuplicateMode"
              size="mini"
              type="success"
              icon="el-icon-document-copy"
              @click="handleDuplicate"
            >
              Duplicate
            </el-button>
            <el-button
              :disabled="isSaving"
              class="cancel-button"
              size="mini"
              type="warning"
              icon="el-icon-close"
              @click="handleCancel"
            >
              {{ $t('button.cancel') }}
            </el-button>
            <el-button
              :disabled="isLoading"
              :loading="isSaving"
              class="save-button"
              size="mini"
              type="primary"
              icon="el-icon-upload2"
              @click="handleSave"
            >
              {{ $t('button.save') }}
            </el-button>
          </div>
        </div>
      </div>
    </template>

    <el-form
      ref="dealPostForm"
      :model="dealPostForm"
      label-width="150px"
    >
      <el-form-item 
        v-if="!isEditMode && preDealPostId === 0"
        prop="info"
      >
        <span slot="label">Info.</span>
        <el-input v-model="info"/>
      </el-form-item>

      <el-form-item v-if="!isEditMode && preDealPostId === 0">
        <span slot="label">&nbsp;</span>
        <el-button
          type="primary"
          @click="handleCopySubject"
        >
          Copy Subject
        </el-button>
      </el-form-item>

      <el-form-item 
        v-if="!isEditMode"
        prop="emailContent"
      >
        <span slot="label">Email Content</span>
        <el-input 
          type="textarea" 
          v-model="emailContent"
          :disabled="preDealPostId > 0"
          autosize
        />
      </el-form-item>

      <el-form-item v-if="!isEditMode && preDealPostId === 0">
        <span slot="label">&nbsp;</span>
        <el-button
          type="primary"
          @click="handleAutoFill"
        >
          Auto Fill
        </el-button>
      </el-form-item>

      <div
        v-if="isEditMode"
        style="font-size: 21px; font-weight: bold;"
      >
        {{ pctDateTime }}
      </div>
      <hr v-if="isEditMode">

      <el-form-item :label="$t('table.date')">
        <el-date-picker
          v-model="dealPostForm.date"
          :clearable="false"
          :placeholder="$t('placeholder.pickDay')"
          type="date"
          value-format="yyyy-MM-dd"
          :disabled="isEditMode"
        />
      </el-form-item>

      <el-form-item prop="time">
        <span slot="label">Time</span>
        <el-input v-model="dealPostForm.time"/>
      </el-form-item>

      <el-form-item prop="name">
        <span slot="label">Name</span>
        <el-input v-model="dealPostForm.name"/>
      </el-form-item>

      <el-form-item prop="brandName">
        <span slot="label">Brand Name</span>
        <el-input v-model="dealPostForm.brandName"/>
      </el-form-item>

      <el-form-item
        label="Gender"
        prop="webAppBannerGender"
      >
        <span slot="label">Gender</span>
        <el-radio
          v-model="dealPostForm.webAppBannerGender"
          label="W"
          size="large"
          border
        >
          Women
        </el-radio>
        
        <el-radio
          v-model="dealPostForm.webAppBannerGender"
          label="M"
          size="large"
          border
        >
          Men
        </el-radio>

        <el-radio
          v-model="dealPostForm.webAppBannerGender"
          label="K"
          size="large"
          border
        >
          Kids
        </el-radio>
      </el-form-item>

      <el-form-item
        label="Is CPC?"
        prop="isCPC"
      >
        <el-radio
          v-model="dealPostForm.isCPC"
          label="1"
          size="large"
          border
          :disabled="isEditMode"
        >
          Yes
        </el-radio>
        
        <el-radio
          v-model="dealPostForm.isCPC"
          label="0"
          size="large"
          border
          :disabled="isEditMode"
        >
          No
        </el-radio>
      </el-form-item>

      <el-form-item
        v-if="dealPostForm.isCPC === '1'"
        label="Store"
        prop="selectedCPCStore"
      >
        <gx-select
          v-model="dealPostForm.selectedCPCStore"
          :show-label="false"
          :options="cpcStores"
          track-by="id"
          label="name"
          :disabled="isEditMode"
        >
          <template #selectedLabel="{ option }">
            {{ option.store_name }} ({{ option.start_date }} - {{ option.end_date }})
          </template>
          <template #option="{ option }">
            <div class="d-flex justify-content-space-between">
              <span>{{ option.store_name }} ({{ option.start_date }} - {{ option.end_date }})</span>
            </div>
          </template>
        </gx-select>
      </el-form-item>

      <el-form-item
        v-if="dealPostForm.isCPC === '1' && dealPostForm.selectedCPCStore && dealPostForm.selectedCPCStore.marketing_u1s.length > 0 && !isEditMode"
        label="CPC U1"
        prop="selectedCPCMarketingU1"
      >
        <gx-select
          v-model="dealPostForm.selectedCPCMarketingU1"
          :show-label="false"
          :options="dealPostForm.selectedCPCStore.marketing_u1s"
          track-by="marketing_u1"
          label="name"
          :disabled="isEditMode"
          @select="handleCPCMarketingU1Change"
        >
          <template #selectedLabel="{ option }">
            {{ option.brand_name }} ({{ option.marketing_u1 }})
          </template>
          <template #option="{ option }">
            <div class="d-flex justify-content-space-between">
              <span>{{ option.brand_name }} ({{ option.marketing_u1 }})</span>
            </div>
          </template>
        </gx-select>
      </el-form-item>

      <el-form-item
        v-if="dealPostForm.isCPC === '0'"
        label="Store"
        prop="selectedStore"
      >
        <gx-select
          v-model="dealPostForm.selectedStore"
          :show-label="false"
          :options="stores"
          track-by="gx_deeplink_advertiser_id"
          label="name"
          :disabled="isEditMode"
        >
          <template #selectedLabel="{ option }">
            {{ option.name }}
          </template>

          <template #option="{ option }">
            <div class="d-flex justify-content-space-between">
              <span>{{ option.name }} ({{ option.gx_deeplink_advertiser_id }})</span>
              <span style="color: #F56C6C">{{ option.gx_deeplink_affiliate }}</span>
            </div>
          </template>
        </gx-select>
      </el-form-item>

      <div v-if="dealPostForm.selectedCPCStore || dealPostForm.selectedStore">
        <el-form-item
          label="Store Type"
          prop="selectedStoreType"
        >
          <gx-select
            v-model="dealPostForm.selectedStoreType"
            :show-label="false"
            :options="storeTypes"
            track-by="id"
            label="name"
            :disabled="isEditMode"
            style="max-width: 160px;"
          >
            <template #selectedLabel="{ option }">{{ option.name }}</template>
            <template #option="{ option }">{{ option.name }}</template>
          </gx-select>
        </el-form-item>

        <el-form-item
          label="Advertising Platform"
          prop="selectedAdvertisingPlatform"
        >
          <gx-select
            v-model="dealPostForm.selectedAdvertisingPlatform"
            :show-label="false"
            :options="advertisingPlatforms"
            track-by="id"
            label="name"
            :disabled="isEditMode"
            style="max-width: 160px;"
          >
            <template #selectedLabel="{ option }">{{ option.name }}</template>
            <template #option="{ option }">{{ option.name }}</template>
          </gx-select>
        </el-form-item>

        <el-form-item
          label="Type"
          prop="selectedType"
        >
          <gx-select
            v-model="dealPostForm.selectedType"
            :show-label="false"
            :options="types"
            track-by="id"
            label="name"
            :disabled="isEditMode"
            style="max-width: 160px;"
          >
            <template #selectedLabel="{ option }">{{ option.name }}</template>
            <template #option="{ option }">{{ option.name }}</template>
          </gx-select>
        </el-form-item>

        <el-form-item
          label="Country"
          prop="country"
        >
          <gx-select
            v-model="dealPostForm.selectedCountry"
            :show-label="false"
            :options="countries"
            track-by="value"
            label="name"
            :disabled="isEditMode"
            style="max-width: 160px;"
          >
            <template #selectedLabel="{ option }">{{ option.name }}</template>
            <template #option="{ option }">{{ option.name }}</template>
          </gx-select>
        </el-form-item>

        <el-form-item prop="aiMessage">
          <span slot="label">AI Message</span>
          <el-input 
            type="textarea" 
            v-model="aiMessage"
            autosize
          />
        </el-form-item>

        <el-form-item>
          <span slot="label">&nbsp;</span>
          <el-button
            v-clipboard:copy="aiMessage"
            v-clipboard:success="copySuccessedForAI"
            type="primary"
          >
            Copy AI Message
          </el-button>
        </el-form-item>

        <el-form-item prop="aiResult">
          <span slot="label">AI Result</span>
          <el-input 
            type="textarea" 
            v-model="aiResult"
            autosize
          />
        </el-form-item>

        <el-form-item>
          <span slot="label">&nbsp;</span>
          <el-button
            type="primary"
            @click="handleFillContent"
          >
            Fill
          </el-button>
        </el-form-item>

        <el-form-item 
          v-if="isEditMode && !isWebAppOrInstagram"
          prop="facebookCampaignId"
        >
          <span slot="label">Campaign ID</span>
          <span>{{ dealPostForm.facebookCampaignId }}</span>
        </el-form-item>

        <el-form-item 
          v-if="isEditMode && !isWebAppOrInstagram"
          prop="facebookAdSetId"
        >
          <span slot="label">Ad Set ID</span>
          <span>{{ dealPostForm.facebookAdSetId }}</span>
        </el-form-item>

        <el-form-item 
          v-if="isEditMode && !isWebAppOrInstagram"
          prop="adName"
        >
          <span slot="label">Ad Name</span>
          <span>{{ dealPostForm.adName }}</span>
        </el-form-item>

        <el-form-item 
          v-if="isEditMode"
          prop="marketingU1"
        >
          <span slot="label">Marketing U1</span>
          <span>{{ dealPostForm.marketingU1 }}</span>
        </el-form-item>

        <el-form-item v-if="isEditMode && !isInstagram">
          <span slot="label">Banner</span>
          <el-button
            type="primary"
            :disabled="!isAllowCreateBanner"
            @click="handleCreateBanner"
          >
            Create Banner
          </el-button>
        </el-form-item>

        <div v-if="!isInstagram">
          <h4 class="title">Banner Images</h4>

          <el-form-item>
            <span slot="label">Image</span>
            <img 
              :src="dealPostForm.webAppBannerImage"
              style="max-width: 300px;"
            />
          </el-form-item>

          <el-form-item prop="webAppBannerImage">
            <span slot="label">Web/App Banner</span>
            <el-input 
              v-model.trim="dealPostForm.webAppBannerImage"
              placeholder="https://"
            />
          </el-form-item>

          <el-form-item>
            <span slot="label">Image</span>
            <img 
              :src="dealPostForm.facebookBannerImage"
              style="max-width: 300px;"
            />
          </el-form-item>

          <el-form-item 
            prop="facebookBannerImage"
          >
            <span slot="label">Facebook Banner</span>
            <el-input 
              v-model.trim="dealPostForm.facebookBannerImage"
              placeholder="https://"
            />
          </el-form-item>

          <h4 class="title">Banner Title</h4>

          <el-form-item prop="webAppBannerTitle">
            <span slot="label">EN</span>
            <el-input v-model.trim="dealPostForm.webAppBannerTitle" />
          </el-form-item>

          <el-form-item prop="webAppBannerTitleZHHK">
            <span slot="label">HK</span>
            <el-input v-model.trim="dealPostForm.webAppBannerTitleZHHK" />
          </el-form-item>

          <el-form-item prop="webAppBannerTitleZHCN">
            <span slot="label">CN</span>
            <el-input v-model.trim="dealPostForm.webAppBannerTitleZHCN" />
          </el-form-item>

          <h4 class="title">Banner Description</h4>

          <el-form-item prop="webAppBannerDesc">
            <span slot="label">EN</span>
            <el-input v-model.trim="dealPostForm.webAppBannerDesc" />
          </el-form-item>

          <el-form-item prop="webAppBannerDescZHHK">
            <span slot="label">HK</span>
            <el-input v-model.trim="dealPostForm.webAppBannerDescZHHK" />
          </el-form-item>

          <el-form-item prop="webAppBannerDescZHCN">
            <span slot="label">CN</span>
            <el-input v-model.trim="dealPostForm.webAppBannerDescZHCN" />
          </el-form-item>

          <el-form-item>
            <span slot="label">&nbsp;</span>
            <el-button
              type="primary"
              @click="handleLocalizeBanner"
            >
              Localize
            </el-button>
          </el-form-item>

          <h4 
            v-if="!isEditMode"
            class="title"
          >
            Banner Tab
          </h4>

          <el-form-item
            v-if="!isEditMode"
            label="Tab"
            prop="webAppBannerTab"
          >
            <span slot="label">Tab</span>
            <el-radio
              v-model="dealPostForm.webAppBannerTab"
              label="fashion"
              size="large"
              border
            >
              Fashion
            </el-radio>
            
            <el-radio
              v-model="dealPostForm.webAppBannerTab"
              label="kids"
              size="large"
              border
            >
              Kids
            </el-radio>

            <el-radio
              v-model="dealPostForm.webAppBannerTab"
              label="beauty"
              size="large"
              border
            >
              Beauty
            </el-radio>

            <el-radio
              v-model="dealPostForm.webAppBannerTab"
              label="bags"
              size="large"
              border
            >
              Bags
            </el-radio>
            
            <el-radio
              v-model="dealPostForm.webAppBannerTab"
              label="shoes"
              size="large"
              border
            >
              Shoes
            </el-radio>

            <el-radio
              v-model="dealPostForm.webAppBannerTab"
              label="lifestyle"
              size="large"
              border
            >
              Lifestyle
            </el-radio>
          </el-form-item>
        </div>

        <div v-if="!isWebAppOrInstagram">
          <h4 class="title">Facebook Deal Post</h4>

          <el-form-item prop="title">
            <span slot="label">Title</span>
            <el-input v-model="dealPostForm.title"/>
          </el-form-item>

          <el-form-item prop="description">
            <span slot="label">Content</span>
            <el-input 
              type="textarea" 
              v-model="dealPostForm.description"
              autosize
            />
          </el-form-item>

          <el-form-item prop="footer">
            <span slot="label">Footer</span>
            <el-input 
              type="textarea" 
              v-model="dealPostForm.footer"
              autosize
            />
          </el-form-item>
        </div>

        <h4 class="title">Shop Now Link</h4>

        <el-form-item prop="shopNowLink">
          <span slot="label">Shop Now Link</span>
          <el-input 
            v-model.trim="dealPostForm.shopNowLink"
            placeholder="https://"
          />
        </el-form-item>

        <el-form-item v-if="dealPostForm.shopNowPaylink !== ''">
          <span slot="label">Shop Now Paylink</span>
          <span>{{ dealPostForm.shopNowPaylink }}</span>
        </el-form-item>

        <el-form-item v-if="dealPostForm.shopNowShortUrl !== ''">
          <span slot="label">Shop Now Bitly</span>
          <el-link
            :href="dealPostForm.shopNowShortUrl"
            target="_blank"
            style="color:#0096FF;"
          >
            {{ dealPostForm.shopNowShortUrl }}
          </el-link>
        </el-form-item>

        <div v-if="!isWebAppOrInstagram">
          <h4 class="title">Product Links</h4>

          <div v-if="!isEditMode">
            <el-form-item prop="productCurrency">
              <span slot="label">Currency</span>
              <el-input 
                style="max-width: 60px;"
                v-model.trim="dealPostForm.productCurrency"
              />
              <span style="margin-left: 8px;">(Remarks: Remove the currency to skip product name input)</span>
            </el-form-item>

            <el-form-item prop="productPrices">
              <span slot="label">Prices</span>
              <el-input 
                type="textarea" 
                v-model="dealPostForm.productPrices"
                :disabled="isDisableProductCurrency"
                row="5"
                autosize
              />
            </el-form-item>

            <el-form-item prop="productNames">
              <span slot="label">Names</span>
              <el-input 
                type="textarea" 
                v-model="dealPostForm.productNames"
                row="5"
                autosize
              />
            </el-form-item>

            <el-form-item>
              <span slot="label">&nbsp;</span>
              <el-button
                type="primary"
                @click="handleTrimProductNames"
              >
                Trim
              </el-button>
            </el-form-item>

            <el-form-item prop="productRawLinks">
              <span slot="label">Links</span>
              <el-input 
                type="textarea" 
                v-model="dealPostForm.productRawLinks"
                row="5"
                autosize
              />
            </el-form-item>
          </div>

          <div 
            v-else
            v-for="productLink in dealPostForm.productLinks"
          >
            <el-form-item prop="productName">
              <span slot="label">Product Name #{{productLink.sort}}</span>
              <el-input v-model.trim="productLink.productName"/>
            </el-form-item>

            <el-form-item prop="currency">
              <span slot="label">Currency</span>
              <el-input 
                style="max-width: 60px;"
                v-model.trim="productLink.currency"
              />
            </el-form-item>

            <el-form-item prop="price">
              <span slot="label">Price</span>
              <el-input 
                style="max-width: 120px;"
                v-model.trim="productLink.price"/>
            </el-form-item>

            <el-form-item prop="link">
              <span slot="label">Link</span>
              <el-input 
                v-model.trim="productLink.link"
                placeholder="https://"
              />
            </el-form-item>

            <el-form-item v-if="productLink.paylink !== ''">
              <span slot="label">Paylink</span>
              <span>{{ productLink.paylink }}</span>
            </el-form-item>

            <el-form-item v-if="productLink.shortUrl !== ''">
              <span slot="label">Bitly</span>

              <el-link
                :herf="productLink.shortUrl"
                target="_blank"
                style="color:#0096FF;"
              >
                {{ productLink.shortUrl }}
              </el-link>
            </el-form-item>
          </div>

          <h4 class="title">Facebook Deal Post Preview</h4>

          <el-form-item>
            <span slot="label">Image</span>
            <img 
              :src="dealPostForm.facebookBannerImage"
              style="max-width: 300px;"
            />
          </el-form-item>

          <el-form-item prop="generatedDealPost">
            <span slot="label">Content</span>
            <el-input 
              type="textarea" 
              v-model="generatedDealPost"
              autosize
              readonly
            />
          </el-form-item>

          <el-form-item>
            <span slot="label">&nbsp;</span>
            <el-button
              v-clipboard:copy="generatedDealPost"
              v-clipboard:success="copySuccessed"
              type="primary"
            >
              {{ copyText }}
            </el-button>
          </el-form-item>
        </div>
      </div>
    </el-form>
  <sticky-header-layout>
</template>

<script>
import clipboard from '../../directive/clipboard'
import { getCPCList } from '../../api/paylinks'
import { getAffiliateStoresWithPaging } from '../../api/stores'
import { countryList } from '../../utils/const'

import ListPageHeader from '@/views/layout/components/ListPageHeader.vue'

import BannerService from '../../api/banner'
import DealPostService from '../../api/deal-post'
import PreDealPostService from '../../api/pre-deal-post'

export default {
  name: 'DealPostDetail',
  components: {
    ListPageHeader,
  },
  directives: {
    clipboard,
  },
  props: {
    id: {
      type: [String, Number],
      default: undefined,
    },
  },
  data() {
    return {
      keywords: '',
      info: '',
      emailContent: '',
      aiMessage: '',
      aiResult: '',
      preDealPostId: 0,
      dealPostForm: {
        selectedCPCStore: null,
        selectedCPCMarketingU1: null,
        selectedStore: null,
        selectedStoreType: null,
        selectedAdvertisingPlatform: null,
        selectedType: null,
        selectedCountry: null,
        name: '',
        adName: '',
        date: '',
        time: '',
        isCPC: '',
        marketingU1: '',
        title: '',
        description: '',
        footer: '立即下載 Goxip ▶️ https://goxi.ps/296cTnU\n#goxip #ilovegoxip',
        facebookBannerImage: '',
        webAppBannerImage: '',
        webAppBannerImageCacheW500: '',
        webAppBannerImageCacheW1000: '',
        webAppBannerTitle: '',
        webAppBannerTitleZHHK: '',
        webAppBannerTitleZHCN: '',
        webAppBannerDesc: '',
        webAppBannerDescZHHK: '',
        webAppBannerDescZHCN: '',
        webAppBannerGender: '',
        webAppBannerTab: '',
        facebookCampaignId: '',
        facebookAdSetId: '',
        emailUrl: '',
        shopNowLink: '',
        shopNowPaylink: '',
        shopNowShortUrl: '',
        productLinks: [],
        productCurrency: 'HK$',
        productPrices: '',
        productNames: '',
        productRawLinks: '',
      },
      cpcStores: [],
      stores: [],
      storeTypes: [],
      advertisingPlatforms: [],
      types: [],
      countries: countryList,
      copyText: 'Copy',
      copyAIText: 'Copy AI Message',
      isEditMode: false,
      isDuplicateMode: false,
      isLoading: false,
      isSaving: false,
    }
  },
  async beforeRouteEnter(to, from, next) {
    try {
      const response = await getAffiliateStoresWithPaging({ size: 9999, is_deeplink: 1 })
      next((vm) => { vm._data.stores = response.data.stores }) // eslint-disable-line no-underscore-dangle
    } catch (error) {
      next(new Error('Could not get store list'))
    }
  },
  async mounted() {
    const cpcResponse = await getCPCList()
    this.cpcStores = cpcResponse.data

    const { data } = await DealPostService.listOptions()

    this.storeTypes = data.store_types
    this.advertisingPlatforms = data.advertising_platforms
    this.types = data.types

    for (let i = 1; i <= 5; i++) {
      this.dealPostForm.productLinks.push({
        type: 'product',
        productName: '',
        currency: 'HK$',
        price: '',
        link: '',
        paylink: '',
        shortUrl: '',
        sort: i,
      })
    }

    if (this.id) {
      this.isEditMode = true
      this.isLoading = true

      const response = await DealPostService.load(this.id)
      const dealPost = response.data

      this.dealPostForm.name = dealPost.name
      this.dealPostForm.adName = dealPost.ad_name
      this.dealPostForm.date = dealPost.date
      this.dealPostForm.time = dealPost.time
      this.dealPostForm.brandName = dealPost.brand_name
      this.dealPostForm.isCPC = dealPost.is_cpc.toString()
      this.dealPostForm.marketingU1 = dealPost.marketing_u1
      this.dealPostForm.title = dealPost.title
      this.dealPostForm.description = dealPost.description
      this.dealPostForm.footer = dealPost.footer
      this.dealPostForm.facebookBannerImage = dealPost.facebook_banner_image
      this.dealPostForm.webAppBannerImage = dealPost.web_app_banner_image
      this.dealPostForm.webAppBannerTitle = dealPost.web_app_banner_title
      this.dealPostForm.webAppBannerTitleZHHK = dealPost.web_app_banner_title_zh_hk
      this.dealPostForm.webAppBannerTitleZHCN = dealPost.web_app_banner_title_zh_cn
      this.dealPostForm.webAppBannerDesc = dealPost.web_app_banner_desc
      this.dealPostForm.webAppBannerDescZHHK = dealPost.web_app_banner_desc_zh_hk
      this.dealPostForm.webAppBannerDescZHCN = dealPost.web_app_banner_desc_zh_cn
      this.dealPostForm.webAppBannerGender = dealPost.web_app_banner_gender
      this.dealPostForm.facebookCampaignId = dealPost.facebook_campaign_id
      this.dealPostForm.facebookAdSetId = dealPost.facebook_ad_set_id
      this.dealPostForm.emailUrl = dealPost.email_url
      this.dealPostForm.productLinks = []

      dealPost.links.forEach(link => {
        if (link.type === 'shop_now') {
          this.dealPostForm.shopNowLink = link.link
          this.dealPostForm.shopNowPaylink = link.paylink
          this.dealPostForm.shopNowShortUrl = link.short_url
        } else if (link.type === 'product') {
          this.dealPostForm.productLinks.push({
            type: 'product',
            productName: link.product_name,
            currency: link.currency,
            price: link.price,
            link: link.link,
            paylink: link.paylink,
            shortUrl: link.short_url,
            sort: link.sort,
          })
        }
      })

      const selectedStores = this.stores.filter(item => item.id === dealPost.store_id)
      const selectedStoreTypes = this.storeTypes.filter(item => item.name === dealPost.store_type)
      const selectedAdvertisingPlatforms = this.advertisingPlatforms.filter(item => item.id === dealPost.advertising_platform_id)
      const selectedTypes = this.types.filter(item => item.id === dealPost.type_id)
      const selectedCountries = this.countries.filter(item => item.value.toLowerCase() === dealPost.country_code.toLowerCase())

      if (selectedStores.length > 0) {
        this.dealPostForm.selectedStore = selectedStores[0]
      }

      if (selectedStoreTypes.length > 0) {
        this.dealPostForm.selectedStoreType = selectedStoreTypes[0]
      }

      if (selectedAdvertisingPlatforms.length > 0) {
        this.dealPostForm.selectedAdvertisingPlatform = selectedAdvertisingPlatforms[0]
      }

      if (selectedTypes.length > 0) {
        this.dealPostForm.selectedType = selectedTypes[0]
      }

      if (selectedCountries.length > 0) {
        this.dealPostForm.selectedCountry = selectedCountries[0]
      }

      if (this.dealPostForm.isCPC === '1') {
        const selectedCPCStores = this.cpcStores.filter(item => item.store_id === dealPost.store_id)

        if (selectedCPCStores.length > 0) {
          this.dealPostForm.selectedCPCStore = selectedCPCStores[0]

          const selectedCPCMarketingU1s = selectedCPCStores[0].marketing_u1s.filter(item => item.marketing_u1 === dealPost.marketing_u1)

          if (selectedCPCMarketingU1s.length > 0) {
            this.dealPostForm.selectedCPCMarketingU1 = selectedCPCMarketingU1s[0]
          }
        }
      }

      this.isLoading = false
    } else {
      const preDealPostId = this.$route.query.pre_deal_post_id

      if (preDealPostId > 0) {
        this.preDealPostId = preDealPostId

        const preDealPostResponse = await PreDealPostService.load(preDealPostId)
        
        this.autoFillPreDealPostData(preDealPostResponse.data)
      } else {
        const today = new Date
        this.dealPostForm.date = today.toISOString().slice(0, 10)
      }

      const defaultStoreTypes = this.storeTypes.filter(item => item.is_default)
      const defaultAdvertisingPlatforms = this.advertisingPlatforms.filter(item => item.is_default)
      const defaultTypes = this.types.filter(item => item.is_default)
      const defaultCountries = this.countries.filter(item => item.value === 'HK')

      if (defaultStoreTypes.length > 0) {
        this.dealPostForm.selectedStoreType = defaultStoreTypes[0]
      }

      if (defaultAdvertisingPlatforms.length > 0) {
        this.dealPostForm.selectedAdvertisingPlatform = defaultAdvertisingPlatforms[0]
      }

      if (defaultTypes.length > 0) {
        this.dealPostForm.selectedType = defaultTypes[0]
      }

      if (defaultCountries.length > 0) {
        this.dealPostForm.selectedCountry = defaultCountries[0]
      }
    }
  },
  computed: {
    pctDateTime() {
      const { date, time } = this.dealPostForm

      const timeMatch = (time || '').match(/^(\d{1,2}):(\d{2})/)

      if (!date || !timeMatch) {
        return ''
      }

      const [year, month, day] = date.split('-').map(Number)
      const [, hour, minute] = timeMatch

      const hktMs = Date.UTC(year, month - 1, day, Number(hour), Number(minute))
      const pctDate = new Date(hktMs - 15 * 60 * 60 * 1000)

      const pad = (n) => String(n).padStart(2, '0')

      return `${pctDate.getUTCFullYear()}-${pad(pctDate.getUTCMonth() + 1)}-${pad(pctDate.getUTCDate())} ${pad(pctDate.getUTCHours())}:${pad(pctDate.getUTCMinutes())}`
    },
    isWebAppOrInstagram() {
      const advertisingPlatform = this.dealPostForm.selectedAdvertisingPlatform

      return (advertisingPlatform && (advertisingPlatform.name === 'Website' || advertisingPlatform.name === 'Instagram'))
    },
    isInstagram() {
      const advertisingPlatform = this.dealPostForm.selectedAdvertisingPlatform

      return (advertisingPlatform && advertisingPlatform.name === 'Instagram')
    },
    isAllowCreateBanner() {
      return (this.dealPostForm.shopNowShortUrl !== '' && this.dealPostForm.webAppBannerImage !== '')
    },
    isDisableProductCurrency() {
      return (this.dealPostForm.productCurrency === '')
    },
    generatedDealPost() {
      let content = ''

      if (this.dealPostForm.title !== '') {
        content += `【${this.dealPostForm.title}】\n\n`
      }

      if (this.dealPostForm.shopNowShortUrl) {
        content += `即買 ▶️: ${this.dealPostForm.shopNowShortUrl}\n\n`
      } else {
        content += '即買 ▶️: <<LINK HERE>>\n\n'
      }

      if (this.dealPostForm.description !== '') {
        content += `${this.dealPostForm.description}\n\n`
      }

      this.dealPostForm.productLinks.forEach(productLink => {
        if (productLink.link !== '') {
          if (productLink.currency === '') {
            content += `${productLink.productName} ▶️: `
          } else {
            content += `${productLink.sort}. ${productLink.productName}`

            if (productLink.price !== '') {
              content += ` - ${productLink.currency}${productLink.price}`
            }

            content += '\n'
          }

          if (productLink.shortUrl !== '') {
            content += `${productLink.shortUrl}\n\n`
          } else {
            content += '<<LINK HERE>>\n\n'
          }
        }
      })

      content += `${this.dealPostForm.footer}`

      return content
    },
    adIds() {
      return `${this.dealPostForm.facebookCampaignId}\t${this.dealPostForm.facebookAdSetId}`
    }
  },
  methods: {
    async handleActionAfterCopyAdContent() {
      try {
        await navigator.clipboard.writeText(this.generatedDealPost)

        if (this.dealPostForm.emailUrl !== '') {
          window.open(this.dealPostForm.emailUrl, '_blank')
        }

        setTimeout(() => {
          window.open('https://business.facebook.com/latest/composer/?asset_id=924047480982525&business_id=229855474191413&nav_ref=internal_nav&ref=biz_web_content_manager_calendar_view&context_ref=CONTENT_CALENDAR', '_blank')
        }, 100)

        if (this.dealPostForm.shopNowShortUrl !== '') {
          setTimeout(() => {
            window.open(this.dealPostForm.shopNowShortUrl, '_blank')
          }, 200)
        }
      } catch (err) {
        console.error(err)
      }
    },
    handleDuplicate() {
      this.isEditMode = false
      this.isDuplicateMode = true
      this.dealPostForm.adName = ''
      this.dealPostForm.date = '',
      this.dealPostForm.time = '',
      this.dealPostForm.isCPC = ''
      this.dealPostForm.marketingU1 = ''
      this.dealPostForm.shopNowShortUrl = ''

      for (let i = 0; i < this.dealPostForm.productLinks.length; i++) {
        this.dealPostForm.productLinks[i].shortUrl = ''
      }
    },
    async handleSave() {
      if (!this.isEditMode) {
        // Convert Links
        const currency = this.dealPostForm.productCurrency
        const productPrices = this.dealPostForm.productPrices.split('\n').filter(item => item.length > 0)
        const productNames = this.dealPostForm.productNames.split('\n').filter(item => item.length > 0)
        const productRawLinks = this.dealPostForm.productRawLinks.split('\n').filter(item => item.length > 0)

        if ((currency === '' || productPrices.length === productRawLinks.length) && productNames.length === productRawLinks.length) {
          for (let i = 0; i < this.dealPostForm.productLinks.length; i++) {
            if (i < productNames.length) {
              this.dealPostForm.productLinks[i].productName = productNames[i]

              if (currency !== '') {
                this.dealPostForm.productLinks[i].price = productPrices[i]
              }
              
              this.dealPostForm.productLinks[i].link = productRawLinks[i]
            }

            this.dealPostForm.productLinks[i].currency = currency
          }
        } else {
          this.handleSaveFail('Number of product price / name / link mismatch.')
          return
        }
      }

      if (!this.isAllLinksAreValid()) {
        this.handleSaveFail('The URL does not match the selected store.')
        return
      }

      if (this.dealPostForm.isCPC === '') {
        this.handleSaveFail('Please select CPC.')
        return
      }

      if (this.dealPostForm.isCPC === '1' && !this.dealPostForm.selectedCPCStore) {
        this.handleSaveFail('Please select Store.')
        return
      }

      if (this.dealPostForm.isCPC === '1' && this.dealPostForm.selectedCPCStore.marketing_u1s.length > 0 && this.dealPostForm.marketingU1 === '') {
        this.handleSaveFail('Please select CPC U1.')
        return
      }

      if (this.dealPostForm.name === '') {
        this.handleSaveFail('Please input name.')
        return
      }

      if (this.dealPostForm.date === '') {
        this.handleSaveFail('Please select date.')
        return
      }

      this.isSaving = true

      let storeId = 0
      let storeType = ''
      let advertisingPlatformId = 0
      let typeId = 0
      let countryCode = ''
      let brandName = ''
      let cpcCampaignId = 0
      let marketingU1 = this.dealPostForm.marketingU1

      if (this.dealPostForm.isCPC === '1' && this.dealPostForm.selectedCPCStore) {
        storeId = this.dealPostForm.selectedCPCStore.store_id
        cpcCampaignId = this.dealPostForm.selectedCPCStore.id
      } else if (this.dealPostForm.isCPC === '0' && this.dealPostForm.selectedStore) {
        storeId = this.dealPostForm.selectedStore.id
      }

      if (this.dealPostForm.selectedStoreType) {
        storeType = this.dealPostForm.selectedStoreType.name
      }

      if (this.dealPostForm.selectedAdvertisingPlatform) {
        advertisingPlatformId = this.dealPostForm.selectedAdvertisingPlatform.id
      }

      if (this.dealPostForm.selectedType) {
        typeId = this.dealPostForm.selectedType.id
      }

      if (this.dealPostForm.selectedCountry) {
        countryCode = this.dealPostForm.selectedCountry.value
      }

      const dealPost = {
        name: this.dealPostForm.name,
        country_code: countryCode,
        date: this.dealPostForm.date,
        time: this.dealPostForm.time,
        store_type: storeType,
        advertising_platform_id: advertisingPlatformId,
        type_id: typeId,
        store_id: storeId,
        brand_name: this.dealPostForm.brandName,
        is_cpc: parseInt(this.dealPostForm.isCPC),
        cpc_campaign_id: cpcCampaignId,
        marketing_u1: marketingU1,
        title: this.dealPostForm.title,
        description: this.dealPostForm.description,
        footer: this.dealPostForm.footer,
        facebook_banner_image: this.dealPostForm.facebookBannerImage,
        web_app_banner_image: this.dealPostForm.webAppBannerImage,
        web_app_banner_image_cache_w500: this.dealPostForm.webAppBannerImageCacheW500,
        web_app_banner_image_cache_w1000: this.dealPostForm.webAppBannerImageCacheW1000,
        web_app_banner_title: this.dealPostForm.webAppBannerTitle,
        web_app_banner_title_zh_hk: this.dealPostForm.webAppBannerTitleZHHK,
        web_app_banner_title_zh_cn: this.dealPostForm.webAppBannerTitleZHCN,
        web_app_banner_desc: this.dealPostForm.webAppBannerDesc,
        web_app_banner_desc_zh_hk: this.dealPostForm.webAppBannerDescZHHK,
        web_app_banner_desc_zh_cn: this.dealPostForm.webAppBannerDescZHCN,
        web_app_banner_gender: this.dealPostForm.webAppBannerGender,
        web_app_banner_tab: this.dealPostForm.webAppBannerTab,
        email_url: this.dealPostForm.emailUrl,
        links: [],
      }

      dealPost.links.push({
        type: 'shop_now',
        product_name: '',
        currency: '',
        price: '',
        link: this.dealPostForm.shopNowLink,
        sort: 0,
      })

      this.dealPostForm.productLinks.forEach(productLink => {
        dealPost.links.push({
          type: 'product',
          product_name: productLink.productName,
          currency: productLink.currency,
          price: productLink.price,
          link: productLink.link,
          sort: productLink.sort,
        })
      })

      if (this.isEditMode) {
        try {
          const result = await DealPostService.update(this.id, dealPost)
          
          this.isSaving = false
          this.$router.go(0)
        } catch (error) {
          this.handleSaveFail(error)
        }
      } else {
        try {
          const preDealPostId = this.$route.query.pre_deal_post_id
          const result = await DealPostService.create(dealPost)

          if (result.code === 200 && preDealPostId > 0) {
            await PreDealPostService.delete(preDealPostId)
          }

          this.isSaving = false
          this.$router.push({ path: `/deal-post/edit/${result.data.id}` })
        } catch (error) {
          this.handleSaveFail(error)
        }
      }
    },
    isAllLinksAreValid() {
      let links = []

      if (this.dealPostForm.shopNowLink !== '') {
        links.push(this.dealPostForm.shopNowLink)
      }

      this.dealPostForm.productLinks.forEach(productLink => {
        if (productLink.link !== '') {
          links.push(productLink.link)
        }
      })

      const selectedCPCStore = this.dealPostForm.selectedCPCStore
      const selectedStore = this.dealPostForm.selectedStore

      let hasError = false
      let validationTexts = []

      if (this.dealPostForm.isCPC === '1' && selectedCPCStore && selectedCPCStore.validation_text) {
        validationTexts = selectedCPCStore.validation_text.split(',')
      } else if (this.dealPostForm.isCPC === '0' && selectedStore && selectedStore.validation_text) {
        validationTexts = selectedStore.validation_text.split(',')
      }

      if (validationTexts.length > 0) {
        links.forEach(link => {
          const matchWithStoreDomain = !!validationTexts.find(text => link.toLowerCase().includes(text.toLowerCase()))

          if (!matchWithStoreDomain) {
            hasError = true
          }
        })
      }

      return !hasError
    },
    handleCancel() {
      this.goToListPage()
    },
    handleCPCMarketingU1Change(selectedValue) {
      this.dealPostForm.marketingU1 = selectedValue.marketing_u1
      this.dealPostForm.brandName = selectedValue.brand_name
    },
    handleCreate() {
      this.$router.push({ path: '/deal-post/create' })
    },
    async handleSearchDealPost() {
      const response = await DealPostService.list(this.keywords, '', '', 1, 10)
      const { data: dealPosts, pagination } = response

      if (dealPosts && dealPosts.length === 1) {
        this.$router.push({
          path: `/deal-post/edit/${dealPosts[0].id}`,
        })
      } else {
        this.$alert('Error', 'No result', {
          type: 'error',
          confirmButtonText: 'OK',
        })
      }
    },
    async handleCreateBanner() {
      const form = {
        url: this.dealPostForm.shopNowShortUrl,
        title: this.dealPostForm.webAppBannerTitle,
        title_zh_hk: this.dealPostForm.webAppBannerTitleZHHK,
        title_zh_cn: this.dealPostForm.webAppBannerTitleZHCN,
        desc: this.dealPostForm.webAppBannerDesc,
        desc_zh_hk: this.dealPostForm.webAppBannerDescZHHK,
        desc_zh_cn: this.dealPostForm.webAppBannerDescZHCN,
        img: this.dealPostForm.webAppBannerImage,
        img_zh_hk: this.dealPostForm.webAppBannerImage,
        img_zh_cn: this.dealPostForm.webAppBannerImage,
        product_preferred_gender: this.dealPostForm.webAppBannerGender,
        status: 1,
      }

      const result = await BannerService.create(form)

      this.$router.push({
        path: `/banner/edit/${result.data.id}`,
      })
    },
    handleCopySubject() {
      let infoComponents = this.info.split('\t')

      if (infoComponents.length === 7) {
        navigator.clipboard.writeText(`"${infoComponents[2]}"`)
      }
    },
    prepareAiMessageAndProductInfo(emailContent, isPutLowestPriceToBannerDesc) {
      let emailContentRows = emailContent.split('\n')
      let isFreeShipping = (emailContent.indexOf('FREE SHIPPING') >= 0 || this.dealPostForm.name.indexOf('FREE SHIPPING') >= 0)

      if (isFreeShipping) {
        // Fill in banner description
        this.dealPostForm.webAppBannerDesc = `${this.dealPostForm.webAppBannerDesc} + FREE SHIPPING`
      }

      let products = []
      let shopNowLink = ''
      let lowestPrice = 0

      emailContentRows = emailContentRows.map(item => item.trim())

      for (let i = 0; i < emailContentRows.length; i++) {
        let row = emailContentRows[i]

        if (row.indexOf('https://') >= 0) {
          if ((i - 1) >= 0 && (i + 1) < emailContentRows.length) {
            let index = parseInt(emailContentRows[i - 1])
            let price = parseInt(emailContentRows[i + 1])

            if (index >= 1 && index <= 5 && price > 0) {
              products.push({
                url: row,
                price: price
              })

              if (lowestPrice === 0 || price < lowestPrice) {
                lowestPrice = price
              }
            } else if (index >= 1 && index <= 5 && (i + 2) < emailContentRows.length) {
              price = parseInt(emailContentRows[i + 2])

              if ((row !== '' || emailContentRows[i + 1] !== '') && price > 0) {
                // Special handling for line break in url
                products.push({
                  url: `${row.trim()}${emailContentRows[i + 1].trim()}`,
                  price: price
                })

                if (lowestPrice === 0 || price < lowestPrice) {
                  lowestPrice = price
                }
              }
            } else {
              shopNowLink = row
            }
          } else {
            shopNowLink = row
          }
        }
      }

      if (isPutLowestPriceToBannerDesc && lowestPrice > 0) {
        this.dealPostForm.webAppBannerDesc = `FROM HK$${lowestPrice} ${this.dealPostForm.webAppBannerDesc}`
      }

      let title = this.dealPostForm.name.replace(this.dealPostForm.brandName, '').trim()
      let titleComponents = title.split(' ')
      let newTitleComponents = []
      let merchantShortForm = ''

      for (let i = 0; i < titleComponents.length; i++) {
        if (titleComponents[i].indexOf('(') === 0) {
          merchantShortForm = titleComponents[i].replace('(', '').replace(')', '')
        }

        if (merchantShortForm === '') {
          newTitleComponents.push(titleComponents[i])
        }
      }

      title = newTitleComponents.join(' ')

      let lines = []
      lines.push('我而家幫一間廣告公司工作, 要放段字上Facebook吸引人去Click, 最緊要Click完之後會買. 請根據以下資料, 用廣東話口語同埋較多嘅 emojis, 用同上次唔同嘅style按以下次序寫: <短文>, <長文>, <產品列表>.')
      lines.push('')
      lines.push('<長文> : 一段大約150至200字, 廣東話口語 和4-8個emojis, 簡單扼要, 唔好太長氣')
      lines.push('注意係男裝/女裝/童裝/unisex,')
      lines.push('搵下有冇年輕嘅 celebrity, 歐美優先, 日韓次之, 最後係香港，有就要提佢個名, Facebook post 用')
      lines.push('')
      lines.push('<短文> : 大約25至35字, 廣東話口語 和2-4個emojis, 簡單扼要, 唔好太長氣')
      lines.push('如果長文有提及 celebrity, 呢度都要提佢個名')
      lines.push('如果免運費, 一定要寫明"免運費", 如果冇免運費, 就唔駛寫')
      lines.push('如果有最低售價, 就一定要寫, 如果冇 就唔駛寫')
      lines.push('如果有折扣優惠, 就一定要寫, 如果係50% OFF, 直接講"半價", 如果冇 就唔駛寫')
      lines.push('')
      lines.push('<產品列表> : Product name From Product URLs')
      lines.push('')
      lines.push('以下是我收到的資料: ')
      lines.push(this.dealPostForm.brandName)
      lines.push(title)
      lines.push('')

      switch (this.dealPostForm.webAppBannerGender) {
      case 'W':
        lines.push('For WOMEN')
        break
      case 'M':
        lines.push('For MEN')
        break
      case 'K':
        lines.push('For KIDS')
        break
      default:
        lines.push('For UNISEX')
        break
      }

      lines.push(`最低售價: HK$${lowestPrice}`)

      if (isFreeShipping) {
        lines.push('有免運費, 務必提及')
      } else {
        lines.push('沒有免運費, 請勿提及')
      }

      lines.push('')

      lines.push(`Main URL (click to shop): ${shopNowLink}`)
      lines.push('')

      lines.push('Product URLs:')

      products.forEach(product => {
        lines.push(product.url)
      })

      lines.push('')
      lines.push('請勿提及任何 URL, URL 僅供編寫<短文>和<長文>內容作為參考, 例如判斷提及邊個 celebrity, 文章方向')

      this.aiMessage = lines.join('\n')

      this.dealPostForm.shopNowLink = shopNowLink
      this.dealPostForm.productPrices = products.map(item => item.price).join('\n')
      this.dealPostForm.productRawLinks = products.map(item => item.url).join('\n')
    },
    handleAutoFill() {
      // Basic Info

      let isPutLowestPriceToBannerDesc = true

      let infoComponents = this.info.split('\t')

      if (infoComponents.length === 7) {
        let date = infoComponents[0]
        let time = infoComponents[1]
        let name = infoComponents[2]
        let brandName = infoComponents[4]
        let gender = infoComponents[6]

        this.dealPostForm.date = date
        this.dealPostForm.time = time
        this.dealPostForm.name = name
        this.dealPostForm.brandName = brandName

        switch (gender) {
        case 'Female':
          this.dealPostForm.webAppBannerGender = 'W'
          break
        case 'Male':
          this.dealPostForm.webAppBannerGender = 'M'
          break
        case 'Unisex':
          this.dealPostForm.webAppBannerGender = ''
          break
        case 'Unisex (Kids)':
          this.dealPostForm.webAppBannerGender = 'K'
          break
        default:
          break
        }
      }

      // Choose Store

      let nameComponents = this.dealPostForm.name.split(' ')

      if (nameComponents.length > 0) {
        let shortForm = nameComponents[nameComponents.length - 1].replace('(', '').replace(')', '')

        if (shortForm.length > 0) {
          this.stores.forEach(store => {
            if (store.short_form === shortForm.toUpperCase()) {
              this.dealPostForm.selectedStore = store
            }
          })
        }

        // Fill in banner title
        let bannerTitle = this.dealPostForm.name.replace(`(${shortForm})`, '').trim()
        let upToPosition = bannerTitle.indexOf(' UP TO ')

        if (upToPosition > 0) {
          this.dealPostForm.webAppBannerTitle = bannerTitle.substring(0, upToPosition)
          this.dealPostForm.webAppBannerDesc = bannerTitle.substring(upToPosition + 1)

          isPutLowestPriceToBannerDesc = false
        } else {
          this.dealPostForm.webAppBannerTitle = bannerTitle
        }        
      }

      // AI Message and product Info

      this.prepareAiMessageAndProductInfo(this.emailContent, isPutLowestPriceToBannerDesc)
    },
    autoFillPreDealPostData(preDealPost) {
      // Basic Info

      let isPutLowestPriceToBannerDesc = true

      this.dealPostForm.date = preDealPost.date
      this.dealPostForm.time = preDealPost.time
      this.dealPostForm.name = preDealPost.subject
      this.dealPostForm.brandName = preDealPost.brand

      switch (preDealPost.gender) {
      case 'Female':
        this.dealPostForm.webAppBannerGender = 'W'
        break
      case 'Male':
        this.dealPostForm.webAppBannerGender = 'M'
        break
      case 'Unisex':
        this.dealPostForm.webAppBannerGender = ''
        break
      case 'Unisex (Kids)':
        this.dealPostForm.webAppBannerGender = 'K'
        break
      default:
        break
      }

      // Choose Store

      let shortForm = preDealPost.merchant

      if (shortForm.length > 0) {
        this.stores.forEach(store => {
          if (store.short_form === shortForm.toUpperCase()) {
            this.dealPostForm.selectedStore = store
          }
        })
      }

      // Fill in banner title
      let bannerTitle = this.dealPostForm.name.replace(`(${shortForm})`, '').trim()
      let upToPosition = bannerTitle.indexOf(' UP TO ')

      if (upToPosition > 0) {
        this.dealPostForm.webAppBannerTitle = bannerTitle.substring(0, upToPosition)
        this.dealPostForm.webAppBannerDesc = bannerTitle.substring(upToPosition + 1)

        isPutLowestPriceToBannerDesc = false
      } else {
        this.dealPostForm.webAppBannerTitle = bannerTitle
      }        

      // AI Message and product Info

      this.prepareAiMessageAndProductInfo(preDealPost.content, isPutLowestPriceToBannerDesc)

      const imageEndPoint = 'https://image-cache.goxip.com'

      this.dealPostForm.facebookBannerImage = `${imageEndPoint}/${preDealPost.fb_banner}`
      this.dealPostForm.webAppBannerImage = `${imageEndPoint}/${preDealPost.web_banner}`
      this.dealPostForm.webAppBannerImageCacheW500 = `${imageEndPoint}/${preDealPost.web_banner_w500}`
      this.dealPostForm.webAppBannerImageCacheW1000 = `${imageEndPoint}/${preDealPost.web_banner_w1000}`

      this.dealPostForm.emailUrl = preDealPost.url
    },
    handleFillContent() {
      const aiResult = this.aiResult.replace(/\*\*/g, '').replace(/\* /g, '')
      const rows = aiResult.split('\n')

      let currentContentType = ''
      let contentTitle = ''
      let contentDescriptionRows = []
      let productNameRows = []

      const escapedBrandName = this.dealPostForm.brandName.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&')
      const brandNameRegex = new RegExp('^' + escapedBrandName + '\\s*', 'i')

      for (let i = 0; i < rows.length; i++) {
        const row = rows[i]

        if (row === '### <短文>') {
          currentContentType = 'content_title'
        } else if (row === '### <長文>') {
          currentContentType = 'content_description'
        } else if (row === '### <產品列表>') {
          currentContentType = 'product_name'
        } else {
          if (currentContentType === 'content_title' && contentTitle === '' && row !== '') {
            contentTitle = row
            currentContentType = 'content_title'
          } else if (currentContentType === 'content_description' && row !== '---') {
            contentDescriptionRows.push(row)
          } else if (currentContentType === 'product_name' && row !== '') {
            let productNameRow = row.replace(brandNameRegex, '').trim()

            const prefix = 'pre-owned'

            if (productNameRow.toLowerCase().startsWith(prefix)) {
              productNameRow = productNameRow.substring(prefix.length).trim()
            }

            productNameRows.push(productNameRow)
          }
        }
      }

      while (contentDescriptionRows.length > 0 && (!contentDescriptionRows.at(-1) || contentDescriptionRows.at(-1).toString().trim() === '')) {
        contentDescriptionRows.pop()
      }

      while (contentDescriptionRows.length > 0 && (!contentDescriptionRows[0] || contentDescriptionRows[0].toString().trim() === '')) {
        contentDescriptionRows.shift()
      }

      this.dealPostForm.title = contentTitle
      this.dealPostForm.description = contentDescriptionRows.join('\n')
      this.dealPostForm.productNames = productNameRows.join('\n')

      const freeShippingTexts = ['仲有免運費', '今次仲要免運費', '免運費直送']
      
      this.dealPostForm.description = this.dealPostForm.description.replace('仲要享有免運費直送到家', freeShippingTexts[Math.floor(Math.random() * freeShippingTexts.length)])
    },
    handleLocalizeBanner() {
      if (this.dealPostForm.webAppBannerTitle !== '') {
        let webAppBannerTitleZHHK = this.dealPostForm.webAppBannerTitle
        let webAppBannerTitleZHCN = this.dealPostForm.webAppBannerTitle

        let mappings = [
          {en: ' WOMEN JACKETS', zh_hk: ' 女裝外套', zh_cn: ' 女装外套', tab: 'fashion'},
          {en: ' WOMEN SHOES', zh_hk: ' 女裝鞋', zh_cn: ' 女装鞋', tab: 'shoes'},
          {en: ' WOMEN SNEAKERS', zh_hk: ' 女裝波鞋', zh_cn: ' 女装运动鞋', tab: 'shoes'},
          {en: ' WOMEN SCARVES', zh_hk: ' 女裝頸巾', zh_cn: ' 女士围巾', tab: 'fashion'},

          {en: ' WOMEN CLUTCH BAGS', zh_hk: ' 女裝手拿袋', zh_cn: ' 女装手抓包', tab: 'bags'},
          {en: ' WOMEN TOTE BAGS', zh_hk: ' 女裝手提袋', zh_cn: ' 女装手提包', tab: 'bags'},
          {en: ' WOMEN BAGS', zh_hk: ' 女裝手袋', zh_cn: ' 女士包袋', tab: 'bags'},

          {en: ' WOMEN CLOTHING', zh_hk: ' 女裝系列', zh_cn: ' 女装系列', tab: 'fashion'},
          {en: ' WOMEN T-SHIRTS', zh_hk: ' 女裝Tee', zh_cn: ' 女装T恤', tab: 'fashion'},
          {en: ' WOMEN DOWNS', zh_hk: ' 女裝羽絨', zh_cn: ' 女装羽绒', tab: 'fashion'},
          {en: ' WOMEN DRESSES', zh_hk: ' 女裝裙', zh_cn: ' 女装裙', tab: 'fashion'},
          {en: ' WOMEN SANDALS', zh_hk: ' 女裝涼鞋', zh_cn: ' 女装凉鞋', tab: 'shoes'},
          

          {en: ' MEN SHOES', zh_hk: ' 男裝鞋', zh_cn: ' 男装鞋', tab: 'shoes'},
          {en: ' HOMME SHOES', zh_hk: ' 男裝鞋', zh_cn: ' 男装鞋', tab: 'shoes'},
          {en: ' MEN SNEAKERS', zh_hk: ' 男裝波鞋', zh_cn: ' 男装运动鞋', tab: 'shoes'},
          {en: ' MEN LOAFERS', zh_hk: ' 男裝 LOAFERS', zh_cn: ' 男装乐福鞋', tab: 'shoes'},
          {en: ' MEN SCARVES', zh_hk: ' 男裝頸巾', zh_cn: ' 男士围巾', tab: 'fashion'},
          {en: ' MEN BAGS', zh_hk: ' 男裝袋', zh_cn: ' 男装袋', tab: 'bags'},
          {en: ' HOMME BAGS', zh_hk: ' 男裝袋', zh_cn: ' 男装袋', tab: 'bags'},
          {en: ' MEN ACCESSORIES', zh_hk: ' 男士配飾', zh_cn: ' 男士配饰', tab: 'fashion'},
          {en: ' MEN CLOTHING', zh_hk: ' 男裝系列', zh_cn: ' 男装系列', tab: 'fashion'},
          {en: ' MEN T-SHIRTS', zh_hk: ' 男裝Tee', zh_cn: ' 男装T恤', tab: 'fashion'},
          {en: ' MEN DOWNS', zh_hk: ' 男裝羽絨', zh_cn: ' 男装羽绒', tab: 'fashion'},


          {en: 'KIDS CLOTHING', zh_hk: '童裝', zh_cn: '童装', tab: 'kids'},


          {en: 'FLATS SHOES', zh_hk: '平底鞋', zh_cn: '平底鞋', tab: 'shoes'},
          {en: 'FLATS', zh_hk: '平底鞋', zh_cn: '平底鞋', tab: 'shoes'},
          {en: ' PUMPS', zh_hk: ' 高踭鞋', zh_cn: ' 高跟鞋', tab: 'shoes'},
          {en: ' SANDALS', zh_hk: ' 涼鞋', zh_cn: ' 凉鞋', tab: 'shoes'},

          {en: ' SCARVES', zh_hk: ' 頸巾', zh_cn: ' 围巾', tab: 'fashion'},
          {en: ' BEANIE', zh_hk: ' 針織冷帽', zh_cn: ' 毛线帽', tab: 'fashion'},

          {en: ' BACKPACK', zh_hk: ' 背囊', zh_cn: ' 背包', tab: 'bags'},
          {en: ' CLUTCH BAGS', zh_hk: ' 手拿袋', zh_cn: ' 手抓包', tab: 'bags'},
          {en: ' TOTE BAGS', zh_hk: ' 手提袋', zh_cn: ' 手提包', tab: 'bags'},
          {en: ' BAGS', zh_hk: ' 手袋', zh_cn: ' 手提包', tab: 'bags'},

          {en: ' ACCESSORIES', zh_hk: ' 配飾', zh_cn: ' 配饰', tab: 'fashion'},
          {en: ' OUTERWEARS', zh_hk: ' 外套', zh_cn: ' 外套', tab: 'fashion'},
          {en: ' SWEATERS', zh_hk: ' 冷衫', zh_cn: ' 毛衣', tab: 'fashion'},
          {en: ' WALLETS', zh_hk: ' 銀包', zh_cn: ' 钱包', tab: 'fashion'},
          {en: ' JEANS', zh_hk: ' 牛仔褲', zh_cn: ' 牛仔裤', tab: 'fashion'},

          {en: ' CANDLES', zh_hk: ' 香薰蠟燭', zh_cn: ' 香薰蜡烛', tab: 'beauty'},
          {en: ' CANDLE', zh_hk: ' 香薰蠟燭', zh_cn: ' 香薰蜡烛', tab: 'beauty'},

          {en: ' WOMEN ', zh_hk: ' 女裝', zh_cn: ' 女装', tab: ''},
          {en: ' MEN ', zh_hk: ' 男裝', zh_cn: ' 男装', tab: ''}
        ]

        mappings.forEach(item => {
          if (webAppBannerTitleZHHK.indexOf(item.en) >= 0) {
            this.dealPostForm.webAppBannerTab = item.tab
          }

          webAppBannerTitleZHHK = webAppBannerTitleZHHK.replace(item.en, item.zh_hk)
          webAppBannerTitleZHCN = webAppBannerTitleZHCN.replace(item.en, item.zh_cn)
        })

        this.dealPostForm.webAppBannerTitleZHHK = webAppBannerTitleZHHK
        this.dealPostForm.webAppBannerTitleZHCN = webAppBannerTitleZHCN
      }

      if (this.dealPostForm.webAppBannerDesc !== '') {
        let isFreeShipping = false

        let webAppBannerDesc = this.dealPostForm.webAppBannerDesc.toUpperCase()

        if (webAppBannerDesc.indexOf('FREE SHIPPING') >= 0) {
          webAppBannerDesc = webAppBannerDesc.replace(' + FREE SHIPPING', '')
          isFreeShipping = true
        }

        let webAppBannerDescZHHK = webAppBannerDesc
        let webAppBannerDescZHCN = webAppBannerDesc

        if (webAppBannerDesc.indexOf('FROM') >= 0) {
          // e.g. FROM HK$1000

          let components = webAppBannerDesc.split(' ')
          let zhHKComponents = []
          let zhCNComponents = []

          if (components.length > 1) {
            zhHKComponents.push(components[1])
            zhHKComponents.push('起')

            zhCNComponents.push(components[1])
            zhCNComponents.push('起')

            for (let i = 2; i < components.length; i++) {
              zhHKComponents.push(components[i])
              zhCNComponents.push(components[i])
            }
          }

          webAppBannerDescZHHK = zhHKComponents.join('')
          webAppBannerDescZHCN = zhCNComponents.join('')
        }

        if (webAppBannerDesc.indexOf('UP TO') >= 0 && webAppBannerDesc.indexOf('%') >= 0) {
          // e.g. UP TO 55% OFF

          let components = webAppBannerDesc.split(' ')
          let zhHKComponents = []
          let zhCNComponents = []

          let chineseNumbers = ['', '一', '二', '三', '四', '五', '六', '七', '八', '九']

          if (components.length > 2) {
            let percentage = 100 - parseInt(components[2].replace('%', ''))
            let chineseDiscount = ''
            let isHalfPrice = (percentage === 50)

            if (percentage % 10 === 0) {
              chineseDiscount = chineseNumbers[percentage / 10]
            } else {
              chineseDiscount = `${Math.floor(percentage / 10)}${percentage % 10}`
            }

            zhHKComponents.push('低至')
            zhHKComponents.push(isHalfPrice ? '半價' : `${chineseDiscount}折`)

            zhCNComponents.push('低至')
            zhCNComponents.push(isHalfPrice ? '半价' : `${chineseDiscount}折`)

            for (let i = 4; i < components.length; i++) {
              zhHKComponents.push(components[i])
              zhCNComponents.push(components[i])
            }
          }

          webAppBannerDescZHHK = zhHKComponents.join('')
          webAppBannerDescZHCN = zhCNComponents.join('')
        }

        if (isFreeShipping) {
          webAppBannerDescZHHK = `${webAppBannerDescZHHK} + 免運費`
          webAppBannerDescZHCN = `${webAppBannerDescZHCN} + 免运费`
        }

        this.dealPostForm.webAppBannerDescZHHK = webAppBannerDescZHHK
        this.dealPostForm.webAppBannerDescZHCN = webAppBannerDescZHCN
      }
    },
    handleTrimProductNames() {
      this.dealPostForm.productNames = this.dealPostForm.productNames
        .split('\n')
        .map(row => row.replace(/Pre-Owned/gi, '').replace(/\s+/g, ' ').trim())
        .filter(row => row.length > 0)
        .join('\n')
    },
    handleSaveFail(error) {
      this.isSaving = false
      this.$alert(`Error: ${error}`, this.$t('error.somethingWentWrong'), {
        type: 'error',
        confirmButtonText: 'OK',
      })
    },
    goToListPage() {
      this.$router.push({ path: '/deal-post/list' })
    },
    copySuccessed() {
      this.copyText = 'Copied'
      setTimeout(() => {
        this.copyText = 'Copy'
      }, 3000)
    },
    copySuccessedForAI() {
      this.copyAIText = 'Copied'
      setTimeout(() => {
        this.copyAIText = 'Copy AI Message'
      }, 3000)
    }
  }
}
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/view-base.scss";
@import "~@/assets/styles/table.scss";
@import "~@/assets/styles/form.scss";

</style>